import colors from 'constants/colors';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const MapRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  row-gap: 30px;
  padding: ${({scale}) => (`0 ${scale * 150 - 145}px`)};

  .floor {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    .floorNumber {
      width: 100%;
      display: flex;
      align-items: flex-start;
      justify-content: flex-start;
      margin-left: ${({scale}) => ((scale * -300 + 300) + 'px')};
      margin-bottom: ${({scale}) => ((scale * 150 - 130) + 'px')};
      cursor: pointer;

      .infoType {
        font-size: 16px;
        font-weight: bold;
        color: ${colors.grey};
        letter-spacing: 2.5px;
      }

      .number {
        font-size: 16px;
        font-weight: bold;
        color: ${colors.white};
        letter-spacing: 2.5px;
        margin-left: 12px;
      }
    }
  }

  @media only screen and (max-width:1200px){
    flex-direction: column;
  }
`;
